module.exports = __webpack_public_path__ + "img/outdoor-space.eea6c36.jpeg";